import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import SupervisionVT from "./Supervision/SupervisionVT";
import ConnectivityVT from "./Connectivity/ConnectivityVT";
import ControlVT from "./Control/ControlVT";
import RTCampaigns from "./Campaigns/RTCampaigns";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
    marginLeft: "15px",
    marginRight: "15px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

export default function MBMTabs(props) {
  const classes = useStyles();
  const [value, setValue] = useState("0");
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const campaigns_read = permis.includes("mbm_campaigns_read");
  const mbm_access  = permis.includes("mbm_access");
  const mbm_admin  = permis.includes("mbm_admin");
  const currentusertype = localStorage.getItem('userType');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value} className={classes.root}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo3}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
            initialselectedindex={0}
            scrollButtons="auto"
          >
            {mbm_access && <StyledTab label="Supervision" value={"0"} />}
            {campaigns_read && <StyledTab label="Campagnes" value={"1"} />}
            {/* {mbm_admin && <StyledTab label="Pilotage" value={"2"} />} */}
            {mbm_access && <StyledTab label="Connectivité" value={"2"} />}
          </StyledTabs>
          <Typography className={classes.padding} />
        </AppBar>
        <Divider variant="fullWidth" />
        {mbm_access && <TabPanel value="0">{<SupervisionVT />}</TabPanel>}
        {campaigns_read && <TabPanel value="1">{ <RTCampaigns />}</TabPanel>}
        {/* {mbm_admin && <TabPanel value="2">{<ControlVT /> }</TabPanel>} */}
        {mbm_access && <TabPanel value="2">{<ConnectivityVT />}</TabPanel>}
      </div>
    </TabContext>
  );
}
